<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-10 14:59:09
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-08-15 16:06:45
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/invoiceDetail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <div class="btn-wrap">
      <eui-btn type="weak" @click="showAddInvoiceDialog('add')"
        >添加邮寄地址</eui-btn
      >
    </div>
    <div class="address-list">
      <ul>
        <li
          class="address-list-li"
          v-for="(item, index) in invoiceList"
          :key="item.addressId"
          :class="[
            isCurrentInvoice == item.addressId ? 'is-active' : 'default'
          ]"
        >
          <template v-if="index <= showMoreIndex">
            <div class="address-info" @click="handleSelectInvoice(item, index)">
              <span
                :class="[
                  isCurrentInvoice == item.addressId ? 'is-active' : 'default'
                ]"
              ></span>
              <span>{{ item.province }}</span>
              <span>{{ item.city }}</span>
              <span>{{ item.county }}</span>
              <span>{{ item.address }}</span>
              <span>{{ item.realName }}</span>
              <span>{{ item.mobile }}</span>
            </div>
            <div class="handle-wrap">
              <eui-btn type="link" @click="showAddInvoiceDialog('edit', item)"
                >编辑</eui-btn
              >
              <eui-btn
                type="link"
                @click="handleDeleteInvoiceAddress(item.addressId)"
                >删除</eui-btn
              >
            </div>
          </template>
        </li>
        <!-- <li
          class="address-list-li"
          :class="[isActive ? 'is-active' : 'default']"
        >
          <div class="address-info">
            <span :class="[isActive ? 'is-active' : 'default']"></span>
            <span>北京市</span>
            <span>市辖区</span>
            <span>东城区</span>
            <span>风扇电机风口浪尖是里福建省卡</span>
            <span>测试</span>
            <span>3213123312</span>
          </div>
          <div class="handle-wrap">
            <eui-btn type="link" @click="showAddInvoiceDialog">编辑</eui-btn>
            <eui-btn type="link">删除</eui-btn>
          </div>
        </li> -->
      </ul>
    </div>
    <div class="show-more">
      <eui-btn type="link" @click="showMoreItem">{{
        showMoreIndex === invoiceList.length ? '收起地址' : '展开地址'
      }}</eui-btn>
    </div>
    <addInvoiceAddressDialog
      @submitPopupData="invoiceSubmitPopupData"
      @resetPopupData="invoiceResetPopupData"
      :dialogFormVisible="addInvoiveAddressDialogVisible"
      :invoiceAddressTitle="invoiceAddressTitle"
      ref="addInvoiceAddress"
    ></addInvoiceAddressDialog>
    <eDialog
      dialogTitle="提示"
      :centerDialogVisible="deleteInvoiceDialogFormVisible"
      @resetPopupData="handleDeleteInvoiceResetPopupData"
      @submitPopupData="handleDeleteInvoiceSubmitPopupData"
      :popupWidth="'420px'"
    >
      <span>确定删除？</span>
    </eDialog>
  </div>
</template>

<script>
import addInvoiceAddressDialog from './addInvoiceAddressDialog.vue';
import eDialog from '../../../../../../components/common/e-dialog.vue';
import api from '../../../../api/evaluation/index';
export default {
  props: {
    invoiceList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isCurrentInvoice: {
      type: Number
    }
  },
  data() {
    return {
      addInvoiveAddressDialogVisible: false,
      isActive: null,
      addInvoiveDialogVisible: false,
      showMoreIndex: 0,
      currentIndex: 0,
      invoiceTitle: '添加邮寄地址',
      deleteInvoiceDialogFormVisible: false,
      currentInvoiceId: null,
      invoiceDetails: {},
      invoiceAddressTitle: '添加新地址',
      invoiceAddressDetails: {}
    };
  },

  components: { addInvoiceAddressDialog, eDialog },

  computed: {},

  created() {},
  methods: {
    showAddInvoiceDialog(type, item) {
      if (type === 'add') {
        this.invoiceAddressTitle = '添加新地址';
        this.$refs.addInvoiceAddress.getAreaByCountryCode(0);
      } else {
        this.invoiceAddressTitle = '修改地址';
        this.invoiceAddressDetails = item;
        this.$refs.addInvoiceAddress.rowEditHandle(item);
      }

      this.addInvoiveAddressDialogVisible = true;
    },
    invoiceResetPopupData() {
      this.addInvoiveAddressDialogVisible = false;
    },
    invoiceSubmitPopupData() {
      this.addInvoiveAddressDialogVisible = false;
      this.$emit('updateInvoiceListAddress');
    },
    handleSelectInvoice(invoiceInfo, index) {
      this.currentIndex = index;
      this.$emit('handleSelectInvoiceAddress', invoiceInfo);
    },
    showMoreItem() {
      if (this.showMoreIndex === 0) {
        this.showMoreIndex = this.invoiceList.length;
      } else {
        this.$emit('handleInvoiceAddressFold', this.currentIndex);
        this.showMoreIndex = 0;
      }
    },
    // 删除发票
    async handleDeleteInvoiceAddress(addressId) {
      console.log(addressId);
      this.currentInvoiceId = addressId;
      this.deleteInvoiceDialogFormVisible = true;
    },
    // 取消删除发票
    handleDeleteInvoiceResetPopupData() {
      this.currentInvoiceId = null;
      this.deleteInvoiceDialogFormVisible = false;
    },
    // 确定删除发票

    async handleDeleteInvoiceSubmitPopupData() {
      let params = {
        addressId: this.currentInvoiceId
      };
      let res = await api.deleteInvoiceAddress(params);
      if (res.code === '200') {
        this.deleteInvoiceDialogFormVisible = false;
        this.$emit('updateInvoiceListAddress');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.tip-message {
  padding: 15px 10px;
  background: #f4f7ff;
  font-size: 0;
  span {
    line-height: 1;
    color: #666;
    font-size: 14px;
  }
}
.btn-wrap {
  margin-top: 20px;
  margin-bottom: 10px;
}
.address-list {
  .address-list-li {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    &.is-active {
      background: #f5f5f5;
    }
    .address-info {
      font-size: 0;
      line-height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .default {
        display: inline-block;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 1px solid #d9d9d9;
      }
      .is-active {
        width: 18px;
        height: 18px;
        border: 6px solid $main-col;
        border-radius: 9px;
        display: inline-block;
      }
    }
    span {
      margin-right: 10px;
      color: #333;
      font-size: 14px;
      line-height: 1;
    }
  }
}
.show-more {
  font-size: 0;
  margin-top: 12px;
}
</style>
